import { Box, Tooltip } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { Icon } from "@src/components/ui-kit/Icon";

export const AbraFlexiExportedIcon = () => {
  return (
    <Tooltip
      className="bg-ink"
      label={<Trans>Already imported to ABRA Flexi</Trans>}
    >
      <Box ml="2">
        <Icon name="download-02" color="grey.600" />
      </Box>
    </Tooltip>
  );
};
